import { dateLocale } from '../../i18n/format'

/**
 * Is a calendar month only partly covered by the data we have?
 *
 * The SVV import lands nightly, so the current month is always incomplete —
 * on 2026-09-15 the newest eierskifte data was 14.09. A monthly count series
 * therefore ends on a bar roughly half the height of its neighbours, which
 * reads as a collapse in sales rather than as a month that is not over.
 *
 * That is the most consequential kind of chart bug: it is not ugly, it is
 * wrong about the business. A dealer glancing at Ståtid would conclude their
 * September fell off a cliff.
 *
 * @param maned        "YYYY-MM"
 * @param maxDataDate  newest date the data covers, "YYYY-MM-DD" (useMaxDataDate)
 */
export function isPartialMonth(maned: string, maxDataDate: string | null | undefined): boolean {
  if (!maxDataDate) return false
  const [my, mm] = maned.split('-').map(Number)
  const [dy, dm, dd] = maxDataDate.split('-').map(Number)
  if (!my || !mm || !dy || !dm || !dd) return false
  if (my !== dy || mm !== dm) return false
  // Day 0 of the following month is the last day of this one.
  const lastDay = new Date(Date.UTC(my, mm, 0)).getUTCDate()
  return dd < lastDay
}

/** "2026-09-14" -> "14.09.2026", the format the rest of the UI uses. */
export function formatNo(dateStr: string): string {
  const [y, m, d] = dateStr.split('-')
  return `${d}.${m}.${y}`
}

/**
 * Norwegian month name for a "YYYY-MM", for the caveat under a chart.
 * Intl gives us the nb-NO names without shipping a table.
 */
export function monthNameNo(maned: string): string {
  const [y, m] = maned.split('-').map(Number)
  const name = new Intl.DateTimeFormat(dateLocale(), { month: 'long', timeZone: 'UTC' })
    .format(new Date(Date.UTC(y, m - 1, 1)))
  return `${name} ${y}`
}
